import { useChatbotStore, useChatStateStore } from '../../zustand/store';
import compStyle from '../../style/styles/Components.module.css';
import { redirectToPage } from '../../utils/utils';

/**
 * fastfive Greeting 하단에 노출되는 entry 버튼.
 * 시나리오 정의는 chatbot.scenarios (metadata) 에서 옴.
 *
 * 스타일은 시작 예시 문구(`Button__examStatement`)와 동일한 클래스 사용 —
 * 챗봇 metadata 의 colorCode (`--color-prim-100/200/800`)에 자동으로 연동된다.
 * 레이아웃은 가로 wrap 으로, 오른쪽 정렬·여러 줄로 펼쳐짐.
 *
 * - flow: 'redirect' → 부모 컨테이너(EntryView)에 redirect 의도를 위임.
 *     · onPendingRedirect prop 이 있으면 그쪽으로 위임 (greeting 노출 + 지연 redirect)
 *     · 없으면 바로 redirectToPage (fallback)
 * - flow: 'product' | 'formOnly' → scenarioId 세팅 → PreQuestion 단계로 진입
 */
const FastfiveEntryButtons = ({ onPendingRedirect } = {}) => {
    const { chatbot } = useChatbotStore();
    const { setFastfiveScenarioId, setIsPreAnswered } = useChatStateStore();
    const scenarios = chatbot?.scenarios;

    if (!Array.isArray(scenarios) || scenarios.length === 0) {
        return null;
    }

    const handleClick = (scenario) => {
        if (scenario.flow === 'redirect') {
            if (onPendingRedirect) {
                onPendingRedirect(scenario);
            } else if (scenario.redirectUrl) {
                // fallback: 부모가 지연 처리 안 하면 즉시 redirect
                redirectToPage(scenario.redirectUrl);
            }
            return;
        }
        setFastfiveScenarioId(scenario.key);
        // 시나리오를 고르면 그 시나리오의 사전질문부터 다시 받는다.
        // Transaction / ChatFieldBase 의 시나리오 세팅 경로도 같이 리셋한다.
        // 안 하면 isPreAnswered 가 true 로 남은 세션에서 PreQuestion 이 통째로 건너뛰어져
        // 인원·평수 없이 리드가 나간다.
        setIsPreAnswered(false);
    };

    return (
        // 바깥 wrapper 는 우측 정렬용 컬럼 컨테이너.
        // 내부 wrapper 의 너비를 제한해서 1행 3개 + 2행 2개 정도로 wrap 되게 함.
        // 라벨 길이에 따라 미세하게 달라질 수 있으니, 폭은 디자인 픽스되면 다시 조정 가능.
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                padding: '8px 16px',
            }}
        >
            <div
                style={{
                    width: '280px',
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: '8px',
                    justifyContent: 'flex-end',
                }}
            >
                {scenarios.map((scenario) => (
                    <button
                        key={scenario.key}
                        type="button"
                        className={`${compStyle.Button__examStatement} example-btn`}
                        style={{ margin: 0 }}
                        onClick={() => handleClick(scenario)}
                    >
                        <p className="h3">{scenario.label}</p>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default FastfiveEntryButtons;
